import axios from 'axios'

export default {
  importPayments ({ commit }, formData) {
    commit('importPaymentsRequest')
    let url = `/api/payment/import-payments/`

    return axios
      .post(
        url,
        formData,
        {headers: {'Content-Type': 'multipart/form-data'},},
      )
      .then((response) => {
        commit('importPaymentsSuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('importPaymentsFailure', error)
        throw error
      })
  },
  getPaymentByID ({ commit }, paymentID) {
    commit('getPaymentByIDRequest')
    let url = `/api/payment/${paymentID}/`

    return axios
      .get(url)
        .then((response) => {
          commit('getPaymentByIDSuccess', response.data)
          return response
        })
        .catch((error) => {
          commit('getPaymentByIDFailure', error)
          throw error
        })
  },
  getPayments ({ commit }, { ordering = '' }) {
    commit('getPaymentsRequest')
    let url = `/api/payment/?limit=0`

    if (ordering) {
      url += `&ordering=${ordering}`
    }

    return axios
      .get(url)
      .then((response) => {
        commit('getPaymentsSuccess', response.data)
        return response
      })
      .catch((error) => {
        commit('getPaymentsFailure', error)
        throw error
      })
  },
  getPaymentsByEnrollmentId({ commit }, { enrollmentId }) {
    commit('getPaymentsByEnrollmentIdRequest')
    let url = `/api/payment/?enrollment__id=${enrollmentId}`
    return axios
      .get(url)
      .then((response) => {
        commit('getPaymentsByEnrollmentIdSuccess', response.data)
        return response
      })
      .catch((error) => {
        commit('getPaymentsByEnrollmentIdFailure', error)
        throw error
      })
  },
  createPayment ({ commit }, payment) {
    commit('addPaymentRequest')
    let url = `/api/payment/`
    return axios
      .post(url, payment)
      .then((response) => {
        commit('addPaymentSuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('addPaymentFailure', error.response.data)
        throw error.response.data
      })
  },
  updatePayment ({ commit }, payment) {
    commit('updatePaymentRequest')
    let url = `/api/payment/${payment.id}/`
    return axios
      .patch(url, payment)
      .then((response) => {
        commit('updatePaymentSuccess', response.data)
        return response.data
      })
      .catch((error)  => {
        commit('updatePaymentFailure', error.response.data)
        throw error.response.data
      })
  },
  deletePayment({ commit }, payment) {
    commit('deletePaymentRequest')
    let url = `/api/payment/${payment.id}/`
    return axios
      .delete(url, payment)
      .then((response) => {
        commit('deletePaymentSuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('deletePaymentFailure', error.response.data)
        throw error.response.data
      })
  },
}
